import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import type { ReplyRow } from '../outreachTypes';
import { replyTitle, shortAgo } from '../outreachFormat';
import { ReplyLabelChip } from './ReplyLabelChip';
import { ASK_SHORT_TEXT } from './inboxGroups';
import { inboxMessages as messages } from './inboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Inbox.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface InboxRowProps {
  row: ReplyRow;
  isOpen: boolean;
  dim: boolean;
  onOpen: (replyUuid: string) => void;
}

/** One reply of the list (design outreach-v2 m1): name, time, first line, label, what they ask for. */
const InboxRowComponent: React.FC<InboxRowProps> = ({ row, isOpen, dim, onOpen }) => {
  const intl = useIntl();
  const asks = row.asks.map((ask) => intl.formatMessage(ASK_SHORT_TEXT[ask])).join(', ');
  return (
    <button
      type="button"
      className={clsx(
        styles.item,
        isOpen && styles.itemOn,
        dim && styles.itemDim,
        row.handledAt === null && styles.itemUnread
      )}
      onClick={() => onOpen(row.replyUuid)}
      data-testid="inbox-row"
    >
      <div className={shared.grow}>
        <div className={styles.itemName}>
          <b>{replyTitle(row.contactName, row.targetName)}</b>
          <span className={styles.itemTime}>{shortAgo(intl, row.receivedAt)}</span>
        </div>
        <div className={styles.itemSnippet}>{row.snippet}</div>
        <div className={styles.itemChips}>
          <ReplyLabelChip label={row.label} />
          {asks !== '' && <span className={shared.chip}>{intl.formatMessage(messages.asksChip, { asks })}</span>}
          <span className={`${shared.chip} ${shared.chipMuted}`}>{row.songTitle}</span>
        </div>
      </div>
    </button>
  );
};

export const InboxRow = TypedMemo(InboxRowComponent);
